import { useLocation } from "react-router";
import { pageHelpFor } from "../lib/page-docs";

/**
 * The one plain-language line under a page's header, from `page-docs.ts`.
 *
 * Renders nothing when a route has no entry, so a page without help copy is
 * silent rather than showing an empty paragraph. Pass `path` to name the route
 * pattern explicitly; otherwise the current pathname is resolved.
 */
export function PageHelp({ path }: { path?: string } = {}) {
  const { pathname } = useLocation();
  const copy = pageHelpFor(path ?? pathname);
  if (!copy) return null;
  return <p className="page-help">{copy}</p>;
}
